export 

var page = {
    setup: function () {
  
        welcome.init();
        fadeIn.init();
        sliders.init();
        clicks.init();
        subNavs.init();
        cloneNumber.init();
    }
};

var welcome = {
    init: function(){
        if($('body').hasClass('homepage')){
            console.log("%cWebsite by MCMNet.co.uk", "color: #bbb; font-family: sans-serif; font-size: 1.5em; font-weight: bolder;");
        } ;  
    }
};

var fadeIn = {
    init: function(){
        $('.fade-in').addClass('is-visible');
    }
};


var subNavs = {
    init: function(){
        $('#mainNav li').has('ul').each(function(){
            $(this).addClass('has-subnav');
        });
    }
};

var cloneNumber = {
    init: function(){
        $('.header-group__number').clone().insertAfter('.sidebar__close');
    }
};



var clicks = {
    init: function(){

        // Added to any parent of is-active state elements to render 
        // inactive when clicking elsewhere on the page
        $(document).click(function(){
            $('.js-global-close .is-active').removeClass('is-active');
        });

        $('.js-global-close').click(function(e){
            e.stopPropagation();
        });
        
    }
};

var sliders = {
    init: function(){
        $('.hero-slider').slick({
            dots: false,
            arrows: false,
            infinite: true,
            centerMode: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 4000
        });

        $('*[class*="slider"] div').removeClass('is-hidden');
    }
};

/*------------------------------------------------------------------------------------*/
// initialise functions
$(document).ready(page.setup);


// WEBPACK FOOTER //
// ./scripts/main.js